module.exports = __webpack_public_path__ + "img/r-cb1.bce36638.gif";